import { join } from 'node:path'
import yaml from 'yaml'

import type { Reference } from '@scalar-org/entities/project'
import { defaultReference } from '@scalar-org/entities/project'

import type { ConfigFileGetter, ConfigFileSpec } from '@/types'

import type { ConfigReference } from '../legacy'

/** Gets a reference file and resolves its project entry */
export async function resolveReference<F extends ConfigFileSpec>({
  config,
  fileGetter,
  root,
}: {
  config: ConfigReference
  fileGetter: ConfigFileGetter<F>
  root: string
}) {
  // Handle live specs
  if ('liveLink' in config) {
    const reference: Reference = {
      ...defaultReference(),
      specPermalink: config.liveLink,
      description: config.description,
      title: config.name,
    } satisfies Reference

    return {
      reference,
      content: null,
    }
  }

  if ('namespace' in config) {
    const reference: Reference = {
      ...defaultReference(),
      managedDoc: {
        slug: config.slug,
        namespace: config.namespace,
        versions: config.versions,
      },
      description: config.description,
      title: config.name,
    } satisfies Reference

    return {
      reference,
      content: null,
    }
  }

  const file =
    (await fileGetter({
      path: join(root, config.path),
    } as F)) ?? ''

  const parsed = yaml.parse(file)

  const reference: Reference = {
    ...defaultReference(),
    title: config.name || parsed?.info?.title || 'Reference',
    description: config?.description || parsed?.info?.description || '',
  }

  return { reference, content: file, slug: config.slug }
}
